export class Search {
	static readonly type = '[fireInsuranceAgentsSearch] search';
	constructor(
		public payload: {
			searchTerm: string;
			companyId?: string;
		},
	) {}
}
